import React from 'react';
import '../main.css';
import highHome from '../images/highHome.jpeg'; // Banner
import LIBRARY2 from '../images/LIBRARY2.jpeg';
import LAB2 from '../images/LAB2.jpeg';

function Home() {
  const bannerStyle = {
    width: '100%',
    height: '600px',
    backgroundImage: `url(${highHome})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center 57%',
    backgroundRepeat: 'no-repeat',
  };

  const sectionStyle = {
    backgroundColor: '#94a8bdff',
    color: 'white',
    padding: '60px 20px',
  };

  const imageLeftStyle = {
    width: '100%',
    maxWidth: '400px',
    borderRadius: '10px',
    float: 'left',
    marginRight: '20px',
    marginBottom: '20px',
  };

  const imageRightStyle = {
    width: '100%',
    maxWidth: '400px',
    borderRadius: '10px',
    float: 'right',
    marginLeft: '20px',
    marginBottom: '20px',
  };

  const paragraphStyle = {
    fontSize: '1.2rem',
    lineHeight: '1.8',
  };

  return (
    <div className="Home">
      {/* Banner Image */}
      <div style={bannerStyle}></div>

      {/* Main Content Section */}
      <div style={sectionStyle}>
        <div className="container">
          <h1 className="text-center mb-4">Welcome to Highlands High School</h1>

          <p style={paragraphStyle}>
            <img src={LIBRARY2} alt="Library" style={imageLeftStyle} />
            At Highlands High School, we strive to create a learning experience that balances academic rigor with the joy of discovery.
            Our commitment to excellence is matched by a warm, inclusive atmosphere where every student is encouraged to thrive.
            Whether it’s in the classroom, on the playing field, or during extracurricular clubs, our learners are empowered to be the best versions of themselves.
          </p>

          <p style={paragraphStyle}>
            We believe education goes beyond textbooks. Our school fosters strong family values and community ties.
            Parents are not just spectators — they’re active participants in their children's development.
            This partnership helps shape respectful, responsible, and resilient young adults who are ready to take on life’s challenges.
          </p>

          <p style={paragraphStyle}>
            Sports and physical development play a vital role in student life.
            From team sports to personal fitness, our programs teach discipline, teamwork, and perseverance — lessons that serve far beyond school grounds.
          </p>

          <p style={paragraphStyle}>
            <img src={LAB2} alt="Computer Lab" style={imageRightStyle} />
            As the world moves forward, so do we. Our state-of-the-art computer lab keeps learners in touch with the ever-changing tech world.
            Through practical exposure, digital literacy, and guided exploration, students gain confidence navigating modern tools — preparing them for success in higher education and future careers.
          </p>

          <p style={paragraphStyle}>
            Highlands High School is more than a school — it’s a launchpad for tomorrow’s leaders, creators, and change-makers.
            We’re proud of our past, focused on the present, and excited for what’s next.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Home;
